<div [id]="containerId" [class]="containerClass" [class.ad-placeholder-banner__slot--hidden]="isVisible"></div>
<div
    class="ad-placeholder-banner"
    *ngIf="isVisible"
    role="button"
    tabindex="0"
    (click)="showUpgradeModal()"
    (keydown.enter)="showUpgradeModal()"
    (keydown.space)="onSpace($event)">
    <img
        class="ad-placeholder-banner__image"
        src="/assets/images/ad_banner_placeholder.png"
        alt="Upgrade to remove ads" />
</div>
